export interface IJobRequestMap {
  jobRequestData: any
}

class JobRequestMap implements IJobRequestMap {
  jobRequestData: any

  constructor(jobRequestMap?: any) {
    this.jobRequestData = jobRequestMap?.jobRequestData || {}
  }
}

export default JobRequestMap
